const objToQueryString = (obj) =>
    Object.keys(obj)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
        .join('&');

const searchToObj = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    let search = window.location.search;

    if (!search) {
        return {};
    }

    let obj = JSON.parse(
        '{"' +
            decodeURI(search)
                .replace(/\?/g, '')
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
            '"}'
    );

    return obj;
};

export { objToQueryString, searchToObj };
